import { useEffect, useState } from "react"
import { useParams } from 'react-router-dom'
import { Input, Button, Space, Table, Select, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    check_in_user_name: undefined | string,
    check_in_phone: undefined | string,
    inDate: any
}

type pagination = {
    current: number,
    pageSize: number
}

export default function () {

    let { id }: { id: string } = useParams()

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        check_in_user_name: undefined,
        check_in_phone: undefined,
        inDate: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }
        params.report_check_in_id = id;

        handleDate(params, 'inDate', ['check_in_start_day', 'check_in_end_day'])

        axiosTable.get('/finance_center/business_report/check_in_income/detail_page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    return (<div className="common-page">
        {/* 财务中心 -> 经营报表 -> 收入确认报表 -> 入住收入明细 */}
        <BreadCrumb position={['财务中心', '入住收入明细']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => { handleChange(value, 'store_id') }} value={fetchOtherParams.store_id} />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户手机号码" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["入住开始日期", "入住结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="客户姓名" dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="手机号码" dataIndex="check_in_phone" key="check_in_phone" />
                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />
                <Column title="合同金额" dataIndex="deal_agreement_amount" key="deal_agreement_amount" />
                <Column title="合同总天数" dataIndex="check_in_total_days" key="check_in_total_days" />
                <Column title="房型" dataIndex="room_type_name" key="room_type_name" />
                <Column title="房间号" dataIndex="room_number" key="room_number" />
                <Column title="入住时间段" dataIndex="check_in_range_time" key="check_in_range_time" />
                <Column title="入住天数" dataIndex="check_in_range_days" key="check_in_range_days" />
                <Column title="入住时间" dataIndex="check_in_time" key="check_in_time" />
                <Column title="出所时间" dataIndex="check_out_time" key="check_out_time" />
                <Column title="入住金额" dataIndex="check_in_amount" key="check_in_amount" />
                <Column title="间天金额" dataIndex="split_day_amount" key="split_day_amount" />
            </Table>
        </div>
    </div>)
}